export default __webpack_public_path__ + "static/media/icon_lock.f5f12990.svg";